import React from 'react'
import { CCol, CFormLabel, CFormSelect, CRow } from '@coreui/react-pro'
import InfoTooltip from './InfoTooltip'

const range = (length) => Array.from({ length }, (_, i) => i + 1)

const PlayerSelectionLimit = ({ values, onChange, teamSize, isTeamExists }) => {
  const teamSizeLimitValues = range(teamSize || 1)

  return (
    <CRow className="g-3">
      <CCol md={6}>
        <CFormLabel className="fw-bold d-flex align-items-center" htmlFor="max_players_per_team">
          Max Players Per Team
          <InfoTooltip content="The maximum number of players a member can select from a single real-world team." />
        </CFormLabel>
        <CFormSelect
          id="max_players_per_team"
          value={values.max_players_per_team}
          onChange={(e) => onChange('max_players_per_team', e.target.value)}
          disabled={isTeamExists}
        >
          <option value="0">No Limit</option>
          {teamSizeLimitValues.map((number) => (
            <option key={number} value={number}>
              {number}
            </option>
          ))}
        </CFormSelect>
      </CCol>
    </CRow>
  )
}

export default PlayerSelectionLimit
